module.exports = __webpack_public_path__ + "img/fabu.f32088c0.png";